<template>
  <TariffNotificationModal
      ref="modalRef"
      title="Подписка PRO успешно возобновлена"
      :max-width="450"
      @hidden="emit('hidden')"
  >
    <template #default>
      <p class="pause-resumed-modal__text mb-2">
        Период паузы завершён, и ваша подписка PRO была автоматически продлена.
      </p>
      <p class="pause-resumed-modal__text mb-2">
        Оплата за следующий период успешно списана с привязанной карты.
      </p>

      <div class="p-3 mb-2 rounded pause-resumed-modal__important">
        <h3 class="mb-2">Вам снова доступны все возможности PRO:</h3>
        <ul class="mb-0 pause-resumed-modal__list">
          <li>безлимит учеников</li>
          <li>интерактивная онлайн-доска</li>
          <li>звонки</li>
        </ul>
      </div>

      <p class="pause-resumed-modal__text mb-2">
        Приятной работы в Finch!
      </p>
    </template>

    <template #footer></template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';

const emit = defineEmits<{
    (e: 'hidden'): void;
}>();

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});
</script>

<style lang="scss" scoped>
.pause-resumed-modal__text,
.pause-resumed-modal__important {
    font-size: 14px;
}

.pause-resumed-modal__important {
    background-color: var(--bs-primary);
    color: var(--bs-white);
}

.pause-resumed-modal__important h3 {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
}
</style>
